import { render } from "./NotePage.vue?vue&type=template&id=3c35b39e"
import script from "./NotePage.vue?vue&type=script&lang=js"
export * from "./NotePage.vue?vue&type=script&lang=js"

import "./NotePage.vue?vue&type=style&index=0&id=3c35b39e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__